import { Column, ColumnKeys, GetDataGridItemsResponse, SetFiltersRequest } from '../types';
import { GridBaseDataProvider } from '../../../grid/GridBaseDataProvider';
import {
  GetRowsRequest,
  GetSummaryRequest,
  GetSummaryResponse,
  UpdateSettingsRequest,
  UpdateSettingsResponse,
} from '../../../grid/types/common';
import { sanitizeObject } from '../../../utils/sanitization.utils';
import { translateFn } from '../../../utils/translator.helper';

export class MdrSecurityTelemetryExclusionsGridViewDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  private cached: any;

  constructor(public dependencies: any) {
    super();
  }

  async getSummary(request: GetSummaryRequest<ColumnKeys>): Promise<GetSummaryResponse> {
    this.cached = await this.dependencies.api.clients.CompanyTweaks.getExclusions(request).toPromise();

    return sanitizeObject({
      summary: translateFn('{noOfItems} items', {
        noOfItems: this.cached.total,
      }),
      numItems: this.cached.total,
    });
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<GetDataGridItemsResponse> {
    if (!this.cached) {
      this.cached = await this.dependencies.api.clients.CompanyTweaks.getExclusions(request).toPromise();
    }

    return sanitizeObject({ rawEvents: this.cached.data });
  }

  async updateSettings(request: UpdateSettingsRequest<Column>): Promise<UpdateSettingsResponse> {
    return {};
  }

  async setFilters(_request: SetFiltersRequest): Promise<{} | undefined> {
    return {};
  }

  shouldDataReloadOnResetView(): boolean {
    return true;
  }
}
